import React from "react";
import { Spin } from "antd";

/**
 * Loading Component
 * Reusable loading spinner component with consistent styling
 * 
 * @param {Object} props - Component props
 * @param {string} [props.size="large"] - Size of the spinner: "small" | "default" | "large"
 * @param {string} [props.tip="Loading..."] - Loading text to display below spinner
 * @param {boolean} [props.fullScreen=false] - Whether to use full screen height
 * @param {string|number} [props.height] - Custom height (e.g., "400px", 200)
 * @param {string} [props.className] - Additional CSS class name
 */
const Loading = ({ 
  size = "large", 
  tip = "Loading...", 
  fullScreen = false,
  height,
  className = ""
}) => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: fullScreen ? '100vh' : height || '200px',
    width: '100%',
  };

  return (
    <div style={containerStyle} className={className}>
      <Spin size={size} />
      {tip && (
        <div style={{ marginTop: '16px', textAlign: 'center', color: '#666' }}>
          {tip}
        </div>
      )}
    </div>
  );
};

export default Loading;

